export const WORDS = {
  PRODUCT_NAME: "K PAY LATER",
  PRODUCT_DETAIL: "ดูรายละเอียดและสมัคร",
  MERCHANT_JOIN: "ร้านค้าที่ร่วม ",
  MERCHANT_SEARCH: "ค้นหาร้านค้าที่ร่วมรายการ",
  MERCHANT_MAP: "และดูเส้นทางการเดินทางได้ที่นี่",
  MERCHANT_NAME: "ชื่อร้านค้า",
  POPULAR_MERCHANT: "ยอดนิยม",
  ALL_MERCHANT: "ทั้งหมด",
  LOAD_MORE: "โหลดเพิ่มเติม",
  LOADING: "กำลังโหลดข้อมูล",
  NOT_FOUND: "ไม่พบข้อมูล",
  VIEW_ALL: "ดูทั้งหมด",
  REDIRECT_TXT: "ท่านกำลังออกจากเว็บไซต์ของธนาคารเพื่อเข้าสู่ Google Maps หรือเว็บไซต์ร้านค้า",
  NO_LINK_TXT: "ท่านสามารถชำระบิลผ่านแอปพลิเคชัน K+",
  WEB_LINK_TXT:"ท่านกำลังออกจากเว็บไซต์ของธนาคารเพื่อเข้าสู่เว็บไซต์ร้านค้า",
  GG_LINK_TXT: "ท่านกำลังออกจากเว็บไซต์ของธนาคารเพื่อเข้าสู่ Google Maps",
  GO_TO_GG_MAP: "เพื่อเข้าสู่ Google Maps",
  PRESS_TO_CONFIRM: "กดยืนยันเพื่อดำเนินการต่อ",
  PRESS_TO_CONFIRM2: "ท่านกำลังออกจากเว็บไซต์ของธนาคารเพื่อเข้าสู่ Google Maps หรือเว็บไซต์ร้านค้า",
  NO_TXT: "",
  CONFIRM_BTN: "ยืนยัน",
  CANCEL_BTN: "ยกเลิก",
  WEB_BTN: "เว็บไซต์ร้านค้า",
  GG_BTN: "Google Maps",
  CLOSE_BTN: "ปิด",
  SEARCH_RESULT: "ผลลัพธ์การค้นหา",
  SEARCH_RESULT_AMOUNT: "จำนวน",
  SEARCH_RESULT_ROWS: "รายการ",
  MERCHANT: "ร้านค้า",
  PATH_LOGO: "/th/personal/Loan/PersonalLoan/PublishingImages/",
  DEFAULT_LOGO: "kpaydefault.jpg",
};
